import React, {useEffect, useState} from 'react';
import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import Features from './components/Features';
import Dashboard from './components/Dashboard';
import Testimonials from './components/Testimonials';
import Pricing from './components/Pricing';
import Footer from './components/Footer';
import LanguageSelector from './components/LanguageSelector';
import Cta from './components/Cta';
import {translations} from './translations';

function App() {
    const [language, setLanguage] = useState('en');
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    // Initialize language from localStorage or browser preference
    useEffect(() => {
        const preferredLanguage = localStorage.getItem('preferredLanguage');
        const browserLanguage = navigator.language.split('-')[0];

        if (preferredLanguage) {
            setLanguage(preferredLanguage);
        } else if (translations[browserLanguage]) {
            setLanguage(browserLanguage);
        }
    }, []);

    // Update document title when language changes
    useEffect(() => {
        document.title = translations[language]['page-title'];
    }, [language]);

    const changeLanguage = (lang) => {
        setLanguage(lang);
        localStorage.setItem('preferredLanguage', lang);
    };

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    return (
        <div className="App" data-lang={language}>
            <LanguageSelector language={language} changeLanguage={changeLanguage}/>
            <Header
                language={language}
                isMenuOpen={isMenuOpen}
                toggleMenu={toggleMenu}
            />
            <main>
                <Hero language={language}/>
                <Features language={language}/>
                <Dashboard language={language}/>
                <Testimonials language={language}/>
                <Pricing language={language}/>
                <Cta language={language}/>
                {/*<Contract language={language} />*/}
            </main>
            <Footer language={language}/>
        </div>
    );
}

export default App;
